import { render, staticRenderFns } from "./showCategory.vue?vue&type=template&id=7bb95c3b&scoped=true&"
import script from "./showCategory.vue?vue&type=script&lang=js&"
export * from "./showCategory.vue?vue&type=script&lang=js&"
import style0 from "./showCategory.vue?vue&type=style&index=0&id=7bb95c3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb95c3b",
  null
  
)

export default component.exports